
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 18","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.25 13a.75.75 0 001.5 0h-1.5zM5 1l.53-.53a.75.75 0 00-1.06 0L5 1zM.47 4.47a.75.75 0 001.06 1.06L.47 4.47zm8 1.06a.75.75 0 001.06-1.06L8.47 5.53zM15.75 5a.75.75 0 00-1.5 0h1.5zM15 17l-.53.53a.75.75 0 001.06 0L15 17zm4.53-3.47a.75.75 0 10-1.06-1.06l1.06 1.06zm-8-1.06a.75.75 0 10-1.06 1.06l1.06-1.06zM5.75 13V1h-1.5v12h1.5zM1.53 5.53l4-4L4.47.47l-4 4 1.06 1.06zm2.94-4l4 4 1.06-1.06-4-4-1.06 1.06zM14.25 5v12h1.5V5h-1.5zm4.22 7.47l-4 4 1.06 1.06 4-4-1.06-1.06zm-2.94 4l-4-4-1.06 1.06 4 4 1.06-1.06z"}})])
          )
        }
      }
    